import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react-hooks/exhaustive-deps */
import { Icon, TableLoader } from '@livable/saas-react-components';
import { Button,
// Checkbox,
// FormControlLabel,
// FormGroup,
TextField } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ResidentModal from 'src/components/resident/ResidentModal';
import { useStore } from 'src/stores';
import { dateToFormat } from 'src/utils/date';
import { useDelay } from 'src/utils/hooks';
import UnitCell from './UnitCell';
import { MoveOutCell } from './MoveOutCell';
import { ResidentCell } from './ResidentCell';
import { OccupancyCell } from './OccupancyCell';
import BillingOptOutCell from './BillingOptOutCell';
import BalanceCell from './BalanceCell';
import { ActionsCell } from './ActionsCell';
import { RESIDENCY_STATUS_KEY_VALUES } from 'src/constants/residency';
import useStyles from './styles';
import { isValueNumber } from 'src/utils/typeValidators';
import { ResidenciesCheckElement } from './residenciesCheckElement';
import RippleEffect from 'src/components/general/RippleEffect';
import FSEBillModal from 'src/components/resident/ResidentModal/MoveOutTab/FSEBillModal';
import { EnrollmentModal } from 'src/components/resident/EnrollmentModal';
import OccupancyUpdateModal from 'src/components/unit/OccupancyUpdateModal';
// import TableInformationModal from './TableInformationModal';

export const ResidenciesDataGrid = observer(props => {
  var _store$homeDashboardS;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const page = 'Residencies Page';
  const activeResidency = props.activeResidency,
    buildingId = props.buildingId,
    propertyId = props.propertyId,
    searchKey = props.searchKey,
    selectedRows = props.selectedRows,
    setSelectedRows = props.setSelectedRows,
    residenciesFilterStatus = props.residenciesFilterStatus,
    newBillingActivated = props.newBillingActivated;
  const isFinalStatementEstimationEnabled = store.account.featureFlagsStore.isFinalStatementEstimationEnabled;
  const selectedUnit = store.fse.FSEBillModalData;
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    unitsList = _useState2[0],
    setUnitsList = _useState2[1];
  const _useState3 = useState('overview'),
    _useState4 = _slicedToArray(_useState3, 2),
    activeTab = _useState4[0],
    setActiveTab = _useState4[1];
  const _useState5 = useState('livable-solution'),
    _useState6 = _slicedToArray(_useState5, 2),
    livableTab = _useState6[0],
    setLivableTab = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    tenantModalIsOpen = _useState8[0],
    setTenantModalIsOpen = _useState8[1];
  const _useState9 = useState(''),
    _useState0 = _slicedToArray(_useState9, 2),
    currentResidentId = _useState0[0],
    setCurrentResidentId = _useState0[1];
  const _useState1 = useState('N/A'),
    _useState10 = _slicedToArray(_useState1, 2),
    currentUnitName = _useState10[0],
    setCurrentUnitName = _useState10[1];
  const _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    currentAccountId = _useState12[0],
    setCurrentAccountId = _useState12[1];
  const _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isLoading = _useState14[0],
    setIsLoading = _useState14[1];
  const _useState15 = useState(0),
    _useState16 = _slicedToArray(_useState15, 2),
    residenciesCount = _useState16[0],
    setResidenciesCount = _useState16[1];
  const _useState17 = useState(0),
    _useState18 = _slicedToArray(_useState17, 2),
    unitsCount = _useState18[0],
    setUnitsCount = _useState18[1];
  const _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    dataNavigation = _useState20[0],
    setDataNavigation = _useState20[1];
  const _useState21 = useState({
      unitname: null,
      occupancy: null,
      unitData: null
    }),
    _useState22 = _slicedToArray(_useState21, 2),
    modalTempData = _useState22[0],
    setMmodalTempData = _useState22[1];
  const _useState23 = useState({
      pageSize: 25,
      page: 0
    }),
    _useState24 = _slicedToArray(_useState23, 2),
    paginationModel = _useState24[0],
    setPaginationModel = _useState24[1];
  const _useState25 = useState([]),
    _useState26 = _slicedToArray(_useState25, 2),
    sortModel = _useState26[0],
    setSortModel = _useState26[1];
  const getBillingOptIds = (arr1, arr2) => {
    const unique1 = arr1.map(u => u.utilityId).filter(u => arr2.indexOf(u.utilityId) === -1);
    const unique2 = arr2.filter(u => arr1.indexOf(u) === -1);
    return unique1.concat(unique2);
  };
  const getMonetaryValue = value => isValueNumber(value) ? "$".concat(parseFloat(value).toFixed(2)) : 'N/A';
  const getFSEInfos = async residencyIds => {
    const resp = await store.fse.getFSEInfosAsync.run({
      residencyIds
    });
    return resp;
  };
  const getUtilityProviders = async () => {
    const resp = await store.properties.getPropertyUtilityProvidersV3Async.run({
      propertyId
    });
    return resp;
  };
  const submitFinalStatements = async () => {
    const resp = await store.fse.submitFinalStatementsAsync.run({
      residencyId: selectedUnit.residencyId
    });
    return resp;
  };
  const getResidencies = async _ref => {
    var _sortModel$, _sortModel$2;
    let handleSetSortModel = _ref.handleSetSortModel,
      handleSetPaginationModel = _ref.handleSetPaginationModel;
    const resp = await store.residencies.getAllResidenciesRelatedToSpecificBuildingAggregateAsync.run({
      buildingId,
      includeEmptyUnits: true,
      //!(searchKey && searchKey?.length > 0),
      searchQuery: searchKey,
      sortBy: handleSetSortModel && handleSetSortModel !== null && handleSetSortModel !== void 0 && handleSetSortModel.length && handleSetSortModel[0].field ? handleSetSortModel[0].field : (_sortModel$ = sortModel[0]) === null || _sortModel$ === void 0 ? void 0 : _sortModel$.field,
      sortOrder: handleSetSortModel && handleSetSortModel !== null && handleSetSortModel !== void 0 && handleSetSortModel.length && handleSetSortModel[0].sort ? handleSetSortModel[0].sort : (_sortModel$2 = sortModel[0]) === null || _sortModel$2 === void 0 ? void 0 : _sortModel$2.sort,
      page: handleSetPaginationModel && isValueNumber(handleSetPaginationModel === null || handleSetPaginationModel === void 0 ? void 0 : handleSetPaginationModel.page) ? (handleSetPaginationModel === null || handleSetPaginationModel === void 0 ? void 0 : handleSetPaginationModel.page) + 1 : paginationModel.page + 1,
      pageSize: handleSetPaginationModel && isValueNumber(handleSetPaginationModel === null || handleSetPaginationModel === void 0 ? void 0 : handleSetPaginationModel.pageSize) ? handleSetPaginationModel === null || handleSetPaginationModel === void 0 ? void 0 : handleSetPaginationModel.pageSize : paginationModel.pageSize,
      statuses: RESIDENCY_STATUS_KEY_VALUES.Current === residenciesFilterStatus ? [residenciesFilterStatus, RESIDENCY_STATUS_KEY_VALUES.Future] : [residenciesFilterStatus]
    });
    return resp;
  };
  const fetchResidencies = _ref2 => {
    let handleSetSortModel = _ref2.handleSetSortModel,
      handleSetPaginationModel = _ref2.handleSetPaginationModel;
    if (!buildingId) return;
    setIsLoading(true);
    let residencies = {};
    Promise.all([getResidencies({
      handleSetSortModel,
      handleSetPaginationModel
    }).then(resp => {
      residencies = resp === null || resp === void 0 ? void 0 : resp.response;
    }), getUtilityProviders()]).then(async () => {
      var _residencies, _residencies2, _residencies3;
      setResidenciesCount(((_residencies = residencies) === null || _residencies === void 0 ? void 0 : _residencies.residenciesCount) || 0);
      setUnitsCount((_residencies2 = residencies) === null || _residencies2 === void 0 ? void 0 : _residencies2.unitsCount);
      if ((_residencies3 = residencies) !== null && _residencies3 !== void 0 && (_residencies3 = _residencies3.buildingResidency) !== null && _residencies3 !== void 0 && _residencies3.length) {
        var _residencies4;
        // const accountIds = [];
        let currentUnits = [];
        (_residencies4 = residencies) === null || _residencies4 === void 0 || _residencies4.buildingResidency.filter((resident, index, array) => {
          /* NOTE:
                Active residents filtering if in one unit we have currently living resident and already scheduled future enrolment
             */
          if (residenciesFilterStatus === RESIDENCY_STATUS_KEY_VALUES.Current && resident.status === RESIDENCY_STATUS_KEY_VALUES.Future) {
            const fIndex = array.findIndex(i => i.unitId === resident.unitId && i.residencyId !== resident.residencyId && i.status === RESIDENCY_STATUS_KEY_VALUES.Current);
            if (fIndex !== -1 && array[fIndex].moveOutDateOnly !== null && resident.status === RESIDENCY_STATUS_KEY_VALUES.Future) return false;
          }
          return true;
        }).map(item => {
          const unitAlreadyInListIndex = currentUnits.findIndex(i => i.id === item.unitId && item.status !== RESIDENCY_STATUS_KEY_VALUES.Future);
          if (item.accountId) {
            // accountIds.push(item.accountId);

            const unitObjectResident = _objectSpread(_objectSpread({}, item), {}, {
              id: item.unitId,
              accountId: item.accountId,
              Fullname: residenciesFilterStatus !== RESIDENCY_STATUS_KEY_VALUES.Future && String(item.status).toLowerCase() === String(RESIDENCY_STATUS_KEY_VALUES.Future).toLowerCase() ? 'Enrollment is scheduled' : item.fullname,
              Unitname: item.unitName,
              email: item === null || item === void 0 ? void 0 : item.email,
              newEmail: item.newEmail,
              finalStatement: item.finalStatement,
              portalAccessDateOnly: item.portalAccessDateOnly,
              unitData: [item.unitData],
              status: item !== null && item !== void 0 && item.emailConfirmed ? 'active' : 'pending',
              enrolled: item.enrolledDateOnly ? dateToFormat(item.enrolledDateOnly) : 'N/A',
              moveOut: item.moveOutDateOnly ? dateToFormat(item.moveOutDateOnly) : 'N/A',
              occupancy: item.occupancy,
              billingOptIds: getBillingOptIds(item.residencyUtilityOptOuts, item.unitUtilityOptOuts.map(i => i.utilityId) || []),
              averageStatement: getMonetaryValue(item.averageStatement),
              balanceStatus: item === null || item === void 0 ? void 0 : item.accountBalanceStatus,
              balance: "$".concat(item.currentBalance ? parseFloat(item.currentBalance).toFixed(2) : '0'),
              lastStatement: getMonetaryValue(item.lastStatement),
              residencyId: item.residencyId,
              unitResidentStatus: item.status,
              isAutoPayEnabled: item.isAutoPayEnabled,
              isEnrolmentScheduled: RESIDENCY_STATUS_KEY_VALUES.Current === residenciesFilterStatus && item !== null && item !== void 0 && item.enrolledDateOnly ? moment(store.properties.serverBusinessDateOnly).isBefore(moment(item.enrolledDateOnly)) : undefined,
              billingStartDateOnly: item.billingStartDateOnly ? dateToFormat(item.billingStartDateOnly) : 'N/A',
              residencyUtilities: item.residencyUtilities
            });
            if (unitAlreadyInListIndex !== -1) {
              if (unitObjectResident.unitResidentStatus === RESIDENCY_STATUS_KEY_VALUES.Current) currentUnits[unitAlreadyInListIndex] = unitObjectResident;
            } else {
              currentUnits.push(unitObjectResident);
            }
          } else {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            unitAlreadyInListIndex === -1 && currentUnits.push({
              id: item.unitId,
              occupancy: item.occupancy,
              Unitname: item.unitName,
              unitData: [item.unitData],
              vacant: true,
              unitResidentStatus: item.status
            });
          }
        });
        const residencyIdsForFse = currentUnits.map(item => item.residencyId).filter(Boolean);
        if (isFinalStatementEstimationEnabled && residencyIdsForFse.length > 0) {
          try {
            var _fseResp$response;
            const fseResp = await getFSEInfos(residencyIdsForFse);
            const fseStatements = fseResp === null || fseResp === void 0 || (_fseResp$response = fseResp.response) === null || _fseResp$response === void 0 ? void 0 : _fseResp$response.finalStatements;
            if (Array.isArray(fseStatements) && fseStatements.length > 0) {
              const byResidencyId = new Map(fseStatements.map(fs => [fs.residencyId, fs]));
              currentUnits = currentUnits.map(u => {
                if (!u.residencyId) return u;
                const fs = byResidencyId.get(u.residencyId);
                if (!fs) return u;
                return _objectSpread(_objectSpread({}, u), {}, {
                  finalStatement: _objectSpread(_objectSpread({}, u.finalStatement && typeof u.finalStatement === 'object' ? u.finalStatement : {}), fs)
                });
              });
            }
          } catch (e) {
            console.error('getFSEInfos failed', e);
          }
        }
        setUnitsList(currentUnits);
      } else {
        setUnitsList([]);
      }
    }).finally(() => {
      store.residencies.toggleRefreshFlag(false);
      setIsLoading(false);
    });
  };
  const handleSetSortModel = async data => {
    if (!data.length) {
      data = [{
        field: 'Unitname',
        sort: 'asc'
      }];
    }
    setSortModel(data);
    fetchResidencies({
      handleSetSortModel: data,
      handleSetPaginationModel: undefined
    });
  };
  const handleSetPaginationModel = async data => {
    setPaginationModel(data);
    fetchResidencies({
      handleSetSortModel: undefined,
      handleSetPaginationModel: data
    });
  };
  useEffect(() => {
    fetchResidencies({
      handleSetSortModel: undefined,
      handleSetPaginationModel: undefined
    });
  }, [buildingId, residenciesFilterStatus]);
  useEffect(() => {
    if (store.residencies.refreshFlag) fetchResidencies({
      handleSetSortModel: undefined,
      handleSetPaginationModel: undefined
    });
  }, [store.residencies.refreshFlag]);
  useDelay(() => fetchResidencies({
    handleSetSortModel: undefined,
    handleSetPaginationModel: undefined
  }), [searchKey], 1000);
  const changeCurrentResidentId = id => {
    setCurrentResidentId(id);
  };
  const changeCurrentUnitName = name => {
    setCurrentUnitName(name);
  };
  const closeModal = () => {
    fetchResidencies({
      handleSetSortModel: undefined,
      handleSetPaginationModel: undefined
    });
    setTenantModalIsOpen(false);
  };
  const openTenantModal = tab => {
    if (['livable-solution', 'billing-settings', 'occupancy'].includes(tab)) {
      setActiveTab('livable-solution');
      setLivableTab(tab);
    } else {
      setActiveTab(tab);
    }
    setTenantModalIsOpen(true);
  };
  const setNewNavigationParameters = (currAccountId, currResidencyId) => {
    if (unitsList.length <= 1) return;
    const filteredUnitsList = unitsList.filter(item => item.accountId && item.residencyId);
    const currUnitIndex = filteredUnitsList.findIndex(item => item.accountId === currAccountId && item.residencyId === currResidencyId);
    if (currUnitIndex === -1) return;
    const resultData = [];
    if (filteredUnitsList.length <= 1) {
      setDataNavigation(resultData);
      return;
    }
    if (currUnitIndex === 0) {
      resultData.push({
        next: {
          residencyId: filteredUnitsList[currUnitIndex + 1].residencyId,
          unitName: filteredUnitsList[currUnitIndex + 1].Unitname,
          accountId: filteredUnitsList[currUnitIndex + 1].accountId
        }
      });
    } else if (currUnitIndex === filteredUnitsList.length - 1) {
      resultData.push({
        prev: {
          residencyId: filteredUnitsList[currUnitIndex - 1].residencyId,
          unitName: filteredUnitsList[currUnitIndex - 1].Unitname,
          accountId: filteredUnitsList[currUnitIndex - 1].accountId
        }
      });
    } else {
      resultData.push({
        next: {
          residencyId: filteredUnitsList[currUnitIndex + 1].residencyId,
          unitName: filteredUnitsList[currUnitIndex + 1].Unitname,
          accountId: filteredUnitsList[currUnitIndex + 1].accountId
        },
        prev: {
          residencyId: filteredUnitsList[currUnitIndex - 1].residencyId,
          unitName: filteredUnitsList[currUnitIndex - 1].Unitname,
          accountId: filteredUnitsList[currUnitIndex - 1].accountId
        }
      });
    }
    setDataNavigation(resultData);
  };
  const handleCellClick = params => {
    setCurrentUnitName(params.row.Unitname);
    setCurrentAccountId(params.row.accountId);
    setCurrentResidentId(params.row.residencyId);
    setNewNavigationParameters(params.row.accountId, params.row.residencyId);
    if (params.field === 'select' || params.field === 'actions' || params.field === 'fullname' || params.field === 'moveOut' || params.row.vacant || params.row.isEnrolmentScheduled) return;
    let modalTab = 'overview';
    switch (params.field) {
      case 'moveOut':
        modalTab = 'move-out';
        break;
      case 'occupancy':
        modalTab = 'livable-solution';
        break;
      case 'billing':
      case 'billingOpt':
      case 'enrolled':
      case 'billingStartDateOnly':
        modalTab = 'billing-settings';
        break;
      case 'balance':
        modalTab = 'overview';
        break;
    }
    openTenantModal(modalTab);
  };
  const handleNavigation = data => {
    setCurrentAccountId(data.accountId);
    setCurrentResidentId(data.residencyId);
    setCurrentUnitName(data.unitName);
    setNewNavigationParameters(data.accountId, data.residencyId);
    openTenantModal('overview');
  };
  const handleSubmitFinalStatements = () => submitFinalStatements().then(() => {
    toast('success', {
      body: ['Final statement sent']
    });
    fetchResidencies({
      handleSetPaginationModel: undefined,
      handleSetSortModel: undefined
    });
  }).finally(() => store.residencies.toggleRefreshFlag(true));
  const indicators = /*#__PURE__*/React.createElement("span", {
    className: "indicators"
  }, /*#__PURE__*/React.createElement("span", {
    className: "inline-arrow"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-down"
  })), /*#__PURE__*/React.createElement("span", {
    className: "inline-filter"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "equalizer"
  })));
  const renderHeader = (text, rightAlign) => /*#__PURE__*/React.createElement("span", {
    className: rightAlign ? classes.rightAlign : ''
  }, text, indicators);
  const Cell = _ref3 => {
    let field = _ref3.field,
      row = _ref3.row;
    return /*#__PURE__*/React.createElement(React.Fragment, null, row.vacant ? /*#__PURE__*/React.createElement("span", {
      className: classes.disabledCellText
    }, "N/A") : /*#__PURE__*/React.createElement(RippleEffect, {
      className: "".concat(row !== null && row !== void 0 && row.isEnrolmentScheduled ? classes.disabledCellText : classes.cellContent, " cellContent")
    }, field));
  };
  let columns = [{
    field: 'select',
    align: 'center',
    width: 74,
    sortable: false,
    renderCell: params => {
      return /*#__PURE__*/React.createElement(ResidenciesCheckElement, {
        disabled: !!params.row.vacant,
        data: {
          id: params.row.residencyId,
          accountId: params.row.accountId,
          number: params.row.Unitname,
          name: params.row.Fullname,
          occupancy: params.row.occupancy,
          isEmail: !!params.row.email || !!params.row.newEmail
        }
      });
    },
    renderHeader: () => /*#__PURE__*/React.createElement(ResidenciesCheckElement, {
      rows: unitsList
    })
  }, {
    field: 'Unitname',
    hideable: false,
    align: 'right',
    width: 82,
    valueGetter: params => params.row.Unitname,
    renderCell: params => /*#__PURE__*/React.createElement(UnitCell, {
      params: params
    }),
    renderHeader: () => renderHeader(t('general.unit'))
    // sortComparator: (v1, v2) =>
    //   ('' + v1)?.localeCompare(v2, undefined, {
    //     numeric: true,
    //   }),
  }, {
    minWidth: store.company.companyFeatureStore.isAppfolio ? 300 : 393,
    align: 'left',
    field: 'fullname',
    valueGetter: params => params.row.Fullname,
    renderCell: params => /*#__PURE__*/React.createElement(ResidentCell, {
      handleClick: handleCellClick,
      params: params,
      propertyId: propertyId,
      newBillingActivated: newBillingActivated
    }),
    renderHeader: () => renderHeader(t('residencies_page.residencies_cell', {
      residenciesCount: residenciesCount,
      unitsCount: unitsCount
    })),
    flex: 1
  }, {
    field: 'enrolled',
    width: 112,
    headerAlign: 'left',
    align: 'left',
    sortable: false,
    valueGetter: params => params.row.enrolled,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      field: params.row.enrolled,
      row: params.row
    }),
    renderHeader: () => renderHeader(store.company.companyFeatureStore.isAppfolio ? t('residencies_page.move-in_date_cell') : t('residencies_page.enrolled_date_cell'), true)
  }, {
    field: 'moveOut',
    width: 132,
    headerAlign: 'left',
    align: 'left',
    sortable: false,
    valueGetter: params => params.row.moveOut,
    renderCell: params => /*#__PURE__*/React.createElement(MoveOutCell, {
      params: params,
      openTenantModal: openTenantModal,
      changeCurrentResidentId: changeCurrentResidentId,
      changeCurrentUnitName: changeCurrentUnitName
    }),
    renderHeader: () => renderHeader(t('Move-out'), true)
  }, {
    field: 'occupancy',
    width: 77,
    headerAlign: 'right',
    align: 'right',
    sortable: false,
    valueGetter: params => params.row.occupancy,
    renderCell: params => /*#__PURE__*/React.createElement(OccupancyCell, {
      params: params,
      setMmodalTempData: setMmodalTempData
    }),
    renderHeader: () => renderHeader(t('residencies_page.occupancy_cell'), true)
  }, {
    field: 'billingOpt',
    width: 107,
    headerAlign: 'right',
    align: 'right',
    sortable: false,
    renderCell: params => /*#__PURE__*/React.createElement(BillingOptOutCell, {
      params: params,
      propertyUtilities: store.properties.propertyUtilities
    }),
    renderHeader: () => renderHeader(t('residencies_page.utility_enrolment'), true)
  },
  // {
  //   field: 'lastStatement',
  //   width: 102,
  //   headerAlign: 'right',
  //   align: 'right',
  //   sortable: false,
  //   renderCell: params => <Cell field={params.row.lastStatement} row={params.row} />,
  //   renderHeader: () => renderHeader(t('residencies_page.last_statement_cell'), true),
  // },
  {
    align: 'right',
    field: 'averageStatement',
    headerAlign: 'right',
    sortable: false,
    valueGetter: params => params.row.averageStatement,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      field: params.row.averageStatement,
      row: params.row
    }),
    renderHeader: () => renderHeader(t('residencies_page.average_statement_cell'), true),
    width: 100
  }, {
    field: 'balance',
    width: 112,
    headerAlign: 'right',
    align: 'right',
    sortable: false,
    valueGetter: params => params.row.balance,
    renderCell: params => /*#__PURE__*/React.createElement(BalanceCell, {
      params: params
    }),
    renderHeader: () => renderHeader(t('residencies_page.current_balance_cell'), true)
  }, {
    field: 'actions',
    width: 72,
    headerAlign: 'right',
    align: 'right',
    sortable: false,
    filterable: false,
    hideable: false,
    renderCell: params => {
      var _params$row, _params$row2;
      return /*#__PURE__*/React.createElement(React.Fragment, null, !(!params.row.vacant && !((_params$row = params.row) !== null && _params$row !== void 0 && _params$row.isEnrolmentScheduled)) && !store.company.companyFeatureStore.disableAccountOverview && /*#__PURE__*/React.createElement(ActionsCell, {
        buildingId: buildingId,
        params: params,
        propertyId: propertyId,
        setMmodalTempData: setMmodalTempData,
        openTenantModal: openTenantModal,
        changeCurrentResidentId: changeCurrentResidentId,
        changeCurrentUnitName: changeCurrentUnitName
      }), !params.row.vacant && !((_params$row2 = params.row) !== null && _params$row2 !== void 0 && _params$row2.isEnrolmentScheduled) && /*#__PURE__*/React.createElement(ActionsCell, {
        buildingId: buildingId,
        params: params,
        propertyId: propertyId,
        setMmodalTempData: setMmodalTempData,
        openTenantModal: openTenantModal,
        changeCurrentResidentId: changeCurrentResidentId,
        changeCurrentUnitName: changeCurrentUnitName
      }));
    },
    renderHeader: () => /*#__PURE__*/React.createElement("div", {
      className: classes.toolboxWrapperHeader
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "actionIcon",
      size: "small",
      type: "button",
      'custom-attribute': '220-ResidenciesDataGrid'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "dotdotdot"
    })))
  }];
  if (store.company.companyFeatureStore.isAppfolio) {
    const fullnameIndex = columns.findIndex(i => i.field === 'fullname');
    if (fullnameIndex !== -1) {
      columns.splice(fullnameIndex + 2, 0, ...[{
        field: 'billingStartDateOnly',
        width: 112,
        headerAlign: 'left',
        align: 'left',
        sortable: false,
        valueGetter: params => params.row.billingStartDateOnly,
        renderCell: params => /*#__PURE__*/React.createElement(Cell, {
          field: params.row.billingStartDateOnly,
          row: params.row
        }),
        renderHeader: () => renderHeader(t('residencies_page.billing_start_date_cell'), true)
      }]);
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.tableContainer
  }, isLoading || store.buildings.getBuildingAsync.inProgress || store.properties.getPropertiesDashboardAsync.inProgress || store.residencies.getAllResidenciesRelatedToSpecificBuildingV2Async.inProgress || store.units.getUnitsAsync.inProgress ? /*#__PURE__*/React.createElement(TableLoader, null) : /*#__PURE__*/React.createElement(DataGrid, {
    getRowId: row => row.id,
    columns: columns,
    initialState: {
      sorting: {
        sortModel: [{
          field: 'Unitname',
          sort: 'asc'
        },
        // NOTE: disabling undesired sorting fields
        // { field: 'Fullname', sortable: false },
        {
          field: 'enrolled',
          sortable: false
        }, {
          field: 'moveOut',
          sortable: false
        }, {
          field: 'occupancy',
          sortable: false
        }, {
          field: 'billingOpt',
          sortable: false
        },
        // { field: 'lastStatement', sortable: false },
        {
          field: 'averageStatement',
          sortable: false
        }, {
          field: 'balance',
          sortable: false
        }, {
          field: 'actions',
          sortable: false
        }]
      }
    },
    slots: {
      ColumnMenuIcon: () => /*#__PURE__*/React.createElement("span", null),
      BaseButton: properties => /*#__PURE__*/React.createElement(Button, _extends({}, properties, {
        variant: "actionButton"
      })),
      BaseTextField: properties => /*#__PURE__*/React.createElement(TextField, _extends({}, properties, {
        variant: "outlined"
      }))
    },
    slotProps: {
      filterPanel: {
        filterFormProps: {
          columnInputProps: {
            variant: 'outlined'
          },
          operatorInputProps: {
            variant: 'outlined'
          }
        }
      }
    },
    getCellClassName: params => {
      var _params$row3, _params$row4;
      return params.row.vacant || typeof ((_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.isEnrolmentScheduled) === 'boolean' && !!((_params$row4 = params.row) !== null && _params$row4 !== void 0 && _params$row4.isEnrolmentScheduled) ? classes.disabledCell : '';
    },
    isRowSelectable: params => {
      var _params$row5, _params$row6;
      return !params.row.vacant || !(typeof ((_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.isEnrolmentScheduled) === 'boolean' && (_params$row6 = params.row) !== null && _params$row6 !== void 0 && _params$row6.isEnrolmentScheduled);
    },
    onCellClick: handleCellClick,
    onRowSelectionModelChange: newSelectionModel => {
      setSelectedRows(newSelectionModel);
    },
    loading: isLoading || store.units.getUnitsAsync.inProgress || store.buildings.getBuildingAsync.inProgress || store.properties.getPropertiesDashboardAsync.inProgress || store.residencies.getAllResidenciesRelatedToSpecificBuildingV2Async.inProgress,
    disableRowSelectionOnClick: true,
    hideFooterSelectedRowCount: true,
    columnHeaderHeight: 78,
    rowHeight: 78,
    rows: unitsList,
    rowCount: unitsCount,
    rowLength: unitsCount,
    rowSelectionModel: selectedRows,
    onSortModelChange: model => handleSetSortModel(model),
    onPaginationModelChange: model => handleSetPaginationModel(model),
    paginationModel: paginationModel,
    sortModel: sortModel,
    sortingMode: 'server',
    paginationMode: 'server',
    className: classes.grid
  }), /*#__PURE__*/React.createElement(ResidentModal, {
    isOpen: tenantModalIsOpen,
    handleOpen: openTenantModal,
    handleClose: closeModal,
    activeTab: activeTab,
    livableTab: livableTab,
    setActiveTab: setActiveTab,
    activeResidency: activeResidency,
    propertyId: propertyId,
    residencyId: currentResidentId,
    unitName: currentUnitName,
    accountId: currentAccountId,
    handleNavigation: handleNavigation,
    dataNavigation: dataNavigation,
    newBillingActivated: newBillingActivated
  }), store.residencies.dataGrid.occupancyModal && /*#__PURE__*/React.createElement(OccupancyUpdateModal, {
    trigger: /*#__PURE__*/React.createElement("i", {
      id: "DGOccupancyUpdateModal"
    }),
    buildingId: buildingId,
    currentOccupancy: modalTempData.occupancy,
    unitData: modalTempData.unitData
  }), store.residencies.dataGrid.enrollmentModal ? /*#__PURE__*/React.createElement(EnrollmentModal, {
    trigger: /*#__PURE__*/React.createElement("i", {
      id: "DGEnrollmentModal"
    }),
    unitIsDefined: modalTempData.unitname,
    propertyId: propertyId,
    page: page,
    portfolioId: (_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.propertyPortfolioDetails(propertyId)) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.id,
    enablePortfolioSelect: false,
    enablePropertySelect: true,
    newBillingActivated: true
  }) : null, isFinalStatementEstimationEnabled && selectedUnit.residencyId && /*#__PURE__*/React.createElement(FSEBillModal, {
    disabled: store.fse.submitFinalStatementsAsync.inProgress,
    disabledTrigger: true,
    isOpen: store.fse.FSEBillGeneralModalIsOpen,
    propertyId: propertyId,
    residentName: selectedUnit.residentName,
    residencyId: selectedUnit.residencyId,
    setFSEBillModalIsOpen: store.fse.setFSEBillGeneralModalIsOpen,
    submitFSE: handleSubmitFinalStatements,
    triggerType: "disabledTrigger",
    unitName: selectedUnit.unitName
  }));
});